import React, { Component } from "react";
import { Table, Row, Col } from "reactstrap";
// import './test.css';
import ColorComponent from "./SvgColorOverview";
import * as message from "../MessageConstant";
import ProviderUtils from "../../CommonComponent/ProviderUtils";
class SizingHealthAnalysisTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.iconData,
      isAsp:
        this.props.isAsp !== null && this.props.isAsp !== undefined
          ? this.props.isAsp
          : false,
      hostOnly: ProviderUtils.hostOnly(
        this.props.providerName,
        this.props.data.metricsPlatform
      ),
      entityType:
        this.props.entityType !== undefined ? this.props.entityType : "vm",
      typeId: this.props.typeID,
    };
  }
  render() {
    const { data } = this.props;
    const Green = <img src={require("../../../images/Green_01.png")} alt="" />;
    const Red = <img src={require("../../../images/Red_01.png")} alt="" />;
    const Yellow = (
      <img src={require("../../../images/Yellow_01.png")} alt="" />
    );
    let gpuRecommendation = data?.gpuDTO?.find(
      (item) => item.recommendationChoiceNum === 0
    );
    return (
      <div>
        <Row id={`costPerformanceImg${this.state.typeId}`}>
          <div
            className="maindivCollapse"
            style={{ paddingLeft: "96px", display: "flex" }}
          >
            {this.state.data[0].gpu && this.state.data[0].gpu.length > 0 && (
              <ColorComponent
                data={this.state.data[0].gpu}
                isResize={false}
                isAsp={this.state.isAsp}
                entityType={this.state.entityType}
                showCostPerfMarker={true}
                fromOverview={true}
              ></ColorComponent>
            )}

            {this.state.data[0].gpumemory &&
              this.state.data[0].gpumemory.length > 0 && (
                <ColorComponent
                  data={this.state.data[0].gpumemory}
                  isResize={false}
                  showInfo={false}
                  isAsp={this.state.isAsp}
                  entityType={this.state.entityType}
                  // showCostPerfMarker={true}
                  fromOverview={true}
                ></ColorComponent>
              )}

            <ColorComponent
              data={this.state.data[0].cpu}
              isResize={this.props.isResize}
              isAsp={this.state.isAsp}
              entityType={this.state.entityType}
              showCostPerfMarker={
                this.state.data[0].gpu && this.state.data[0].gpu.length > 0
                  ? false
                  : true
              }
              fromOverview={true}
            >
              {" "}
            </ColorComponent>
            {this.state.entityType === "db" ? (
              <ColorComponent
                data={this.state.data[0].disks}
                isResize={this.props.isResize}
                isAsp={this.state.isAsp}
                entityType={this.state.entityType}
                fromOverview={true}
              ></ColorComponent>
            ) : null}
            <ColorComponent
              data={this.state.data[0].memory}
              isResize={this.props.isResize}
              isAsp={this.state.isAsp}
              entityType={this.state.entityType}
              hostOnly={this.state.hostOnly}
              fromOverview={true}
            ></ColorComponent>
            <ColorComponent
              data={this.state.data[0].network}
              isResize={this.props.isResize}
              isAsp={this.state.isAsp}
              entityType={this.state.entityType}
              fromOverview={true}
            ></ColorComponent>
            {this.state.entityType !== "db" ? (
              <ColorComponent
                data={this.state.data[0].disks}
                isResize={this.props.isResize}
                isAsp={this.state.isAsp}
                entityType={this.state.entityType}
                fromOverview={true}
              ></ColorComponent>
            ) : null}
          </div>
        </Row>
        <div
          id={`costPerformanceTable${this.state.typeId}`}
          className="panel"
          style={{ marginTop: "10px" }}
        >
          <Row>
            <Table className="tableview" id="tableSizing" bordered>
              <thead>
                <tr>
                  <td style={{ borderTop: "0px", borderLeft: "0px" }}></td>
                  <th style={{ backgroundColor: "#e5e5e5" }}>Utilization </th>
                  <th style={{ backgroundColor: "#e5e5e5" }}>Cost</th>
                  <th style={{ backgroundColor: "#e5e5e5" }}>Health </th>
                  <th style={{ backgroundColor: "#e5e5e5" }}>Performance</th>
                </tr>
              </thead>
              <tbody>
                {gpuRecommendation?.currentGpuNum > 0 && (
                  <tr>
                    <td>
                      <div className={"GpuClass"}></div>
                      <Col className="tableLeftHead">GPU SM</Col>
                    </td>

                    <td className="textfieldSizing">
                      {gpuRecommendation?.gpuUtilization_util}
                    </td>
                    {gpuRecommendation?.gpuUtilization_cost ===
                    message.CostHigh ? (
                      <td className="textfieldSizing">
                        <div className="sizingHealthColoredTDCenteredDiv">
                          <div
                            style={{ backgroundColor: message.CostHighColor }}
                            className="sizingeHelathColoredTD"
                          >
                            $
                          </div>
                        </div>
                      </td>
                    ) : gpuRecommendation?.gpuUtilization_cost ===
                      message.CostLow ? (
                      <td
                        className="textfieldSizing"
                        style={{ color: "#393939" }}
                      >
                        <div className="sizingHealthColoredTDCenteredDiv">
                          <div
                            style={{
                              backgroundColor: message.CostLowColor,
                              color: "#393939",
                            }}
                            className="sizingeHelathColoredTD"
                          >
                            $$
                          </div>
                        </div>
                      </td>
                    ) : (
                      <td className="textfieldSizing">
                        <div className="sizingHealthColoredTDCenteredDiv">
                          <div
                            style={{ backgroundColor: message.CostOKColor }}
                            className="sizingeHelathColoredTD"
                          >
                            $$$
                          </div>
                        </div>
                      </td>
                    )}
                    <td className="textfieldSizing">
                      {gpuRecommendation?.gpu_sm_health}
                    </td>
                    {gpuRecommendation?.gpu_sm_health === message.HealthGood ? (
                      <td
                        className="textfieldSizing"
                        style={{ color: "white" }}
                      >
                        <div className="sizingHealthColoredTDCenteredDiv">
                          <div
                            style={{
                              backgroundColor: message.HealthGoodColor,
                            }}
                            className="sizingeHelathColoredTD"
                          >
                            {Red}
                          </div>
                        </div>
                      </td>
                    ) : gpuRecommendation?.gpu_sm_health ===
                      message.HealthFair ? (
                      <td
                        className="textfieldSizing"
                        style={{ color: "white" }}
                      >
                        <div className="sizingHealthColoredTDCenteredDiv">
                          <div
                            style={{
                              backgroundColor: message.HealthFairColor,
                            }}
                            className="sizingeHelathColoredTD"
                          >
                            {Yellow}
                          </div>
                        </div>
                      </td>
                    ) : (
                      <td
                        className="textfieldSizing"
                        style={{ color: "white" }}
                      >
                        <div className="sizingHealthColoredTDCenteredDiv">
                          <div
                            style={{
                              backgroundColor: message.HealthPoorColor,
                            }}
                            className="sizingeHelathColoredTD"
                          >
                            {Green}
                          </div>
                        </div>
                      </td>
                    )}
                  </tr>
                )}

                {gpuRecommendation?.currentGpuNum > 0 && (
                  <tr>
                    <td>
                      <div className={"GpuMemoryClass"}></div>
                      <Col className="tableLeftHead">GPU Memory</Col>
                    </td>

                    <td className="textfieldSizing">
                      {gpuRecommendation?.gpuMemUsed_util}
                    </td>
                    {gpuRecommendation?.gpuMemUsed_cost === message.CostHigh ? (
                      <td className="textfieldSizing">
                        <div className="sizingHealthColoredTDCenteredDiv">
                          <div
                            style={{ backgroundColor: message.CostHighColor }}
                            className="sizingeHelathColoredTD"
                          >
                            $
                          </div>
                        </div>
                      </td>
                    ) : gpuRecommendation?.gpuMemUsed_cost ===
                      message.CostLow ? (
                      <td
                        className="textfieldSizing"
                        style={{ color: "#393939" }}
                      >
                        <div className="sizingHealthColoredTDCenteredDiv">
                          <div
                            style={{
                              backgroundColor: message.CostLowColor,
                              color: "#393939",
                            }}
                            className="sizingeHelathColoredTD"
                          >
                            $$
                          </div>
                        </div>
                      </td>
                    ) : (
                      <td className="textfieldSizing">
                        <div className="sizingHealthColoredTDCenteredDiv">
                          <div
                            style={{ backgroundColor: message.CostOKColor }}
                            className="sizingeHelathColoredTD"
                          >
                            $$$
                          </div>
                        </div>
                      </td>
                    )}
                    <td className="textfieldSizing">
                      {gpuRecommendation?.gpu_mem_health}
                    </td>
                    {gpuRecommendation?.gpu_mem_health ===
                    message.HealthGood ? (
                      <td
                        className="textfieldSizing"
                        style={{ color: "white" }}
                      >
                        <div className="sizingHealthColoredTDCenteredDiv">
                          <div
                            style={{
                              backgroundColor: message.HealthGoodColor,
                            }}
                            className="sizingeHelathColoredTD"
                          >
                            {Red}
                          </div>
                        </div>
                      </td>
                    ) : gpuRecommendation?.gpu_mem_health ===
                      message.HealthFair ? (
                      <td
                        className="textfieldSizing"
                        style={{ color: "white" }}
                      >
                        <div className="sizingHealthColoredTDCenteredDiv">
                          <div
                            style={{
                              backgroundColor: message.HealthFairColor,
                            }}
                            className="sizingeHelathColoredTD"
                          >
                            {Yellow}
                          </div>
                        </div>
                      </td>
                    ) : (
                      <td
                        className="textfieldSizing"
                        style={{ color: "white" }}
                      >
                        <div className="sizingHealthColoredTDCenteredDiv">
                          <div
                            style={{
                              backgroundColor: message.HealthPoorColor,
                            }}
                            className="sizingeHelathColoredTD"
                          >
                            {Green}
                          </div>
                        </div>
                      </td>
                    )}
                  </tr>
                )}

                {data.vm.map((key, i) => {
                  return (
                    key?.recommendationChoiceNum === 0 && (
                      <tr>
                        {key?.recommendationChoiceNum === 0 ? (
                          <td rowSpan={1}>
                            <div
                              className={
                                this.state.entityType === "db"
                                  ? "DbCpuClass"
                                  : "CpuClass"
                              }
                            ></div>
                            <Col className="tableLeftHead">
                              {this.state.entityType === "db" ? "vCORE" : "CPU"}
                            </Col>
                          </td>
                        ) : (
                          ""
                        )}
                        <td className="textfieldSizing">
                          {key.current_vcpu_utilisation}
                        </td>
                        {key.current_vcpu_cost === message.CostHigh ? (
                          <td className="textfieldSizing">
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.CostHighColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                $
                              </div>
                            </div>
                          </td>
                        ) : key.current_vcpu_cost === message.CostLow ? (
                          <td
                            className="textfieldSizing"
                            style={{ color: "#393939" }}
                          >
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.CostLowColor,
                                  color: "#393939",
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                $$
                              </div>
                            </div>
                          </td>
                        ) : (
                          <td className="textfieldSizing">
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{ backgroundColor: message.CostOKColor }}
                                className="sizingeHelathColoredTD"
                              >
                                $$$
                              </div>
                            </div>
                          </td>
                        )}
                        <td className="textfieldSizing">
                          {key.current_vcpu_health}
                        </td>
                        {key.current_vcpu_health === message.HealthGood ? (
                          <td
                            className="textfieldSizing"
                            style={{ color: "white" }}
                          >
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.HealthGoodColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                {Red}
                              </div>
                            </div>
                          </td>
                        ) : key.current_vcpu_health === message.HealthFair ? (
                          <td
                            className="textfieldSizing"
                            style={{ color: "white" }}
                          >
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.HealthFairColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                {Yellow}
                              </div>
                            </div>
                          </td>
                        ) : (
                          <td
                            className="textfieldSizing"
                            style={{ color: "white" }}
                          >
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.HealthPoorColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                {Green}
                              </div>
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  );
                })}

                {this.state.entityType === "db"
                  ? data.osdisk.map((key, i) => {
                      return key?.recommendationChoiceNum === 0 ? (
                        <tr>
                          <td rowSpan={1}>
                            <div className="DbOsClass"></div>
                            <Col className="tableLeftHead">MEMORY</Col>
                          </td>
                          <td className="textfieldSizing">
                            {" "}
                            {key.current_os_disk_utilisation}
                          </td>
                          {key.current_os_disk_cost === message.CostHigh ? (
                            <td className="textfieldSizing" style={{}}>
                              <div className="sizingHealthColoredTDCenteredDiv">
                                <div
                                  style={{
                                    backgroundColor: message.CostHighColor,
                                  }}
                                  className="sizingeHelathColoredTD"
                                >
                                  $
                                </div>
                              </div>
                            </td>
                          ) : key.current_os_disk_cost === message.CostLow ? (
                            <td
                              className="textfieldSizing"
                              style={{ color: "black" }}
                            >
                              <div className="sizingHealthColoredTDCenteredDiv">
                                <div
                                  style={{
                                    backgroundColor: message.CostLowColor,
                                  }}
                                  className="sizingeHelathColoredTD"
                                >
                                  $$
                                </div>
                              </div>
                            </td>
                          ) : (
                            <td className="textfieldSizing" style={{}}>
                              <div className="sizingHealthColoredTDCenteredDiv">
                                <div
                                  style={{
                                    backgroundColor: message.CostOKColor,
                                  }}
                                  className="sizingeHelathColoredTD"
                                >
                                  $$$
                                </div>
                              </div>
                            </td>
                          )}
                          <td className="textfieldSizing">
                            {key.current_os_disk_health}
                          </td>
                          {key.current_os_disk_health === message.HealthGood ? (
                            <td
                              className="textfieldSizing"
                              style={{ color: "white" }}
                            >
                              <div className="sizingHealthColoredTDCenteredDiv">
                                <div
                                  style={{
                                    backgroundColor: message.HealthGoodColor,
                                  }}
                                  className="sizingeHelathColoredTD"
                                >
                                  {Red}
                                </div>
                              </div>
                            </td>
                          ) : key.current_os_disk_health ===
                            message.HealthFair ? (
                            <td className="textfieldSizing" style={{}}>
                              <div className="sizingHealthColoredTDCenteredDiv">
                                <div
                                  style={{
                                    backgroundColor: message.HealthFairColor,
                                  }}
                                  className="sizingeHelathColoredTD"
                                >
                                  {Yellow}
                                </div>
                              </div>
                            </td>
                          ) : (
                            <td
                              className="textfieldSizing"
                              style={{ color: "white" }}
                            >
                              <div className="sizingHealthColoredTDCenteredDiv">
                                <div
                                  style={{
                                    backgroundColor: message.HealthPoorColor,
                                  }}
                                  className="sizingeHelathColoredTD"
                                >
                                  {Green}
                                </div>
                              </div>
                            </td>
                          )}
                        </tr>
                      ) : (
                        ""
                      );
                    })
                  : null}

                {data.vm.map((key, i) => {
                  return (
                    key?.recommendationChoiceNum === 0 && (
                      <tr>
                        {key?.recommendationChoiceNum === 0 ? (
                          <td rowSpan={1}>
                            <div
                              className={
                                this.state.entityType === "db"
                                  ? "DbMemoryClass"
                                  : "MemoryClass"
                              }
                            ></div>
                            <Col className="tableLeftHead">
                              {this.state.entityType === "db"
                                ? "DATA DISK"
                                : "MEMORY"}
                            </Col>
                          </td>
                        ) : (
                          ""
                        )}
                        <td className="textfieldSizing">
                          {" "}
                          {this.state.hostOnly
                            ? "N/A"
                            : key.current_memory_utilisation}
                        </td>
                        {this.state.hostOnly ? (
                          <td className="textfieldSizing" style={{}}>
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{ backgroundColor: "gray" }}
                                className="sizingeHelathColoredTD"
                              >
                                N/A
                              </div>
                            </div>
                          </td>
                        ) : key.current_memory_cost === message.CostHigh ? (
                          <td className="textfieldSizing" style={{}}>
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.CostHighColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                $
                              </div>
                            </div>
                          </td>
                        ) : key.current_memory_cost === message.CostLow ? (
                          <td
                            className="textfieldSizing"
                            style={{ color: "black" }}
                          >
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.CostLowColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                $$
                              </div>
                            </div>
                          </td>
                        ) : (
                          <td className="textfieldSizing" style={{}}>
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{ backgroundColor: message.CostOKColor }}
                                className="sizingeHelathColoredTD"
                              >
                                $$$
                              </div>
                            </div>
                          </td>
                        )}
                        <td className="textfieldSizing">
                          {this.state.hostOnly
                            ? "N/A"
                            : key.current_memory_health}
                        </td>
                        {this.state.hostOnly ? (
                          <td
                            className="textfieldSizing"
                            style={{ color: "white" }}
                          >
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{ backgroundColor: "gray" }}
                                className="sizingeHelathColoredTD"
                              >
                                N/A
                              </div>
                            </div>
                          </td>
                        ) : key.current_memory_health === message.HealthGood ? (
                          <td
                            className="textfieldSizing"
                            style={{ color: "white" }}
                          >
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.HealthGoodColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                {Red}
                              </div>
                            </div>
                          </td>
                        ) : key.current_memory_health === message.HealthFair ? (
                          <td className="textfieldSizing" style={{}}>
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.HealthFairColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                {Yellow}
                              </div>
                            </div>
                          </td>
                        ) : (
                          <td
                            className="textfieldSizing"
                            style={{ color: "white" }}
                          >
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.HealthPoorColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                {Green}
                              </div>
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  );
                })}
                {data.vm.map((key, i) => {
                  return (
                    key?.recommendationChoiceNum === 0 && (
                      <tr>
                        {key?.recommendationChoiceNum === 0 ? (
                          <td rowSpan={1}>
                            <div
                              className={
                                this.state.entityType === "db"
                                  ? "DbNetworkClass"
                                  : "NetworkClass"
                              }
                            ></div>
                            <Col className="tableLeftHead">
                              {this.state.entityType === "db"
                                ? "LOG DISK"
                                : "NETWORK"}
                            </Col>
                          </td>
                        ) : (
                          ""
                        )}
                        <td className="textfieldSizing">
                          {key.current_network_utilisation}
                        </td>
                        {key.current_network_cost === message.CostHigh ? (
                          <td className="textfieldSizing" style={{}}>
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.CostHighColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                $
                              </div>
                            </div>
                          </td>
                        ) : key.current_network_cost === message.CostLow ? (
                          <td
                            className="textfieldSizing"
                            style={{ color: "black" }}
                          >
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.CostLowColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                $$
                              </div>
                            </div>
                          </td>
                        ) : (
                          <td className="textfieldSizing" style={{}}>
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{ backgroundColor: message.CostOKColor }}
                                className="sizingeHelathColoredTD"
                              >
                                $$$
                              </div>
                            </div>
                          </td>
                        )}
                        <td className="textfieldSizing">
                          {key.current_network_health}
                        </td>
                        {key.current_network_health === message.HealthGood ? (
                          <td
                            className="textfieldSizing"
                            style={{ color: "white" }}
                          >
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.HealthGoodColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                {Red}
                              </div>
                            </div>
                          </td>
                        ) : key.current_network_health ===
                          message.HealthFair ? (
                          <td className="textfieldSizing" style={{}}>
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.HealthFairColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                {Yellow}
                              </div>
                            </div>
                          </td>
                        ) : (
                          <td
                            className="textfieldSizing"
                            style={{ color: "white" }}
                          >
                            <div className="sizingHealthColoredTDCenteredDiv">
                              <div
                                style={{
                                  backgroundColor: message.HealthPoorColor,
                                }}
                                className="sizingeHelathColoredTD"
                              >
                                {Green}
                              </div>
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  );
                })}
                {this.state.entityType !== "db"
                  ? data.osdisk.map((key, i) => {
                      return key?.recommendationChoiceNum === 0 ? (
                        <tr>
                          <td rowSpan={1 + Object.keys(data.dataDisk).length}>
                            <div className="OsClass"></div>
                            <Col className="tableLeftHead">
                              {this.state.isAsp ? "STORAGE" : "DISK(s)"}
                            </Col>
                          </td>
                          <td className="textfieldSizing">
                            {" "}
                            {key.current_os_disk_utilisation}
                          </td>
                          {key.current_os_disk_cost === message.CostHigh ? (
                            <td className="textfieldSizing" style={{}}>
                              <div className="sizingHealthColoredTDCenteredDiv">
                                <div
                                  style={{
                                    backgroundColor: message.CostHighColor,
                                  }}
                                  className="sizingeHelathColoredTD"
                                >
                                  $
                                </div>
                              </div>
                            </td>
                          ) : key.current_os_disk_cost === message.CostLow ? (
                            <td
                              className="textfieldSizing"
                              style={{ color: "black" }}
                            >
                              <div className="sizingHealthColoredTDCenteredDiv">
                                <div
                                  style={{
                                    backgroundColor: message.CostLowColor,
                                  }}
                                  className="sizingeHelathColoredTD"
                                >
                                  $$
                                </div>
                              </div>
                            </td>
                          ) : (
                            <td className="textfieldSizing" style={{}}>
                              <div className="sizingHealthColoredTDCenteredDiv">
                                <div
                                  style={{
                                    backgroundColor: message.CostOKColor,
                                  }}
                                  className="sizingeHelathColoredTD"
                                >
                                  $$$
                                </div>
                              </div>
                            </td>
                          )}
                          <td className="textfieldSizing">
                            {key.current_os_disk_health}
                          </td>
                          {key.current_os_disk_health === message.HealthGood ? (
                            <td
                              className="textfieldSizing"
                              style={{ color: "white" }}
                            >
                              <div className="sizingHealthColoredTDCenteredDiv">
                                <div
                                  style={{
                                    backgroundColor: message.HealthGoodColor,
                                  }}
                                  className="sizingeHelathColoredTD"
                                >
                                  {Red}
                                </div>
                              </div>
                            </td>
                          ) : key.current_os_disk_health ===
                            message.HealthFair ? (
                            <td className="textfieldSizing" style={{}}>
                              <div className="sizingHealthColoredTDCenteredDiv">
                                <div
                                  style={{
                                    backgroundColor: message.HealthFairColor,
                                  }}
                                  className="sizingeHelathColoredTD"
                                >
                                  {Yellow}
                                </div>
                              </div>
                            </td>
                          ) : (
                            <td
                              className="textfieldSizing"
                              style={{ color: "white" }}
                            >
                              <div className="sizingHealthColoredTDCenteredDiv">
                                <div
                                  style={{
                                    backgroundColor: message.HealthPoorColor,
                                  }}
                                  className="sizingeHelathColoredTD"
                                >
                                  {Green}
                                </div>
                              </div>
                            </td>
                          )}
                        </tr>
                      ) : (
                        ""
                      );
                    })
                  : null}
                {this.state.entityType !== "db"
                  ? Object.keys(data.dataDisk).map((key) => {
                      return data.dataDisk[key].map((value, i) => {
                        return value?.recommendationChoiceNum === 0 ? (
                          <tr className="Rowclass">
                            <td className="textfieldSizing">
                              {value.current_data_disk_utilisation}
                            </td>
                            {value.current_data_disk_cost ===
                            message.CostHigh ? (
                              <td className="textfieldSizing" style={{}}>
                                <div className="sizingHealthColoredTDCenteredDiv">
                                  <div
                                    style={{
                                      backgroundColor: message.CostHighColor,
                                    }}
                                    className="sizingeHelathColoredTD"
                                  >
                                    $
                                  </div>
                                </div>
                              </td>
                            ) : value.current_data_disk_cost ===
                              message.CostLow ? (
                              <td
                                className="textfieldSizing"
                                style={{ color: "black" }}
                              >
                                <div className="sizingHealthColoredTDCenteredDiv">
                                  <div
                                    style={{
                                      backgroundColor: message.CostLowColor,
                                    }}
                                    className="sizingeHelathColoredTD"
                                  >
                                    $$
                                  </div>
                                </div>
                              </td>
                            ) : (
                              <td className="textfieldSizing" style={{}}>
                                <div className="sizingHealthColoredTDCenteredDiv">
                                  <div
                                    style={{
                                      backgroundColor: message.CostOKColor,
                                    }}
                                    className="sizingeHelathColoredTD"
                                  >
                                    $$$
                                  </div>
                                </div>
                              </td>
                            )}
                            <td className="textfieldSizing">
                              {value.current_data_disk_health}
                            </td>
                            {value.current_data_disk_health ===
                            message.HealthGood ? (
                              <td
                                className="textfieldSizing"
                                style={{ color: "white" }}
                              >
                                <div className="sizingHealthColoredTDCenteredDiv">
                                  <div
                                    style={{
                                      backgroundColor: message.HealthGoodColor,
                                    }}
                                    className="sizingeHelathColoredTD"
                                  >
                                    {Red}
                                  </div>
                                </div>
                              </td>
                            ) : value.current_data_disk_health ===
                              message.HealthFair ? (
                              <td className="textfieldSizing" style={{}}>
                                <div className="sizingHealthColoredTDCenteredDiv">
                                  <div
                                    style={{
                                      backgroundColor: message.HealthFairColor,
                                    }}
                                    className="sizingeHelathColoredTD"
                                  >
                                    {Yellow}
                                  </div>
                                </div>
                              </td>
                            ) : (
                              <td
                                className="textfieldSizing"
                                style={{ color: "white" }}
                              >
                                <div className="sizingHealthColoredTDCenteredDiv">
                                  <div
                                    style={{
                                      backgroundColor: message.HealthPoorColor,
                                    }}
                                    className="sizingeHelathColoredTD"
                                  >
                                    {Green}
                                  </div>
                                </div>
                              </td>
                            )}
                          </tr>
                        ) : (
                          ""
                        );
                      });
                    })
                  : null}
              </tbody>
            </Table>
          </Row>
        </div>
      </div>
    );
  }
}
export default SizingHealthAnalysisTable;
